import { Component, inject } from '@angular/core';
import { NxCopytextModule } from '@allianz/ng-aquila/copytext';
import { NxMessageModule } from '@allianz/ng-aquila/message';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  imports: [
    NxCopytextModule,
    NxMessageModule,
    TranslocoPipe,
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
  private activatedRoute = inject(ActivatedRoute);
  debugId = this.activatedRoute.snapshot.queryParams['debugId'];
}
